module.exports = __webpack_public_path__ + "content/algorithm.8fbe7d7d.worker.js"